//stop native BS functionality of closing menu in order to support in-dropdown clicks
$('.dropdown-menu.multiselect-menu').on("click.bs.dropdown", function (e) {
    e.stopPropagation();

    //e.preventDefault();
}); 

$('[data-close-dropdown-trigger]').on('click', function () {
    $(this).closest('.dropdown-container').find('.dropdown-toggle').dropdown('hide');
});